// extracted by mini-css-extract-plugin
export default {"btnPrimary":"button-submit_btnPrimary__B9Afn","primary":"button-submit_primary__xHdQg","delete":"button-submit_delete__YZbUW"};